import { Clock, Info, Funnel } from '@phosphor-icons/react'
import {
  UI_COLOR_RBAC_STATUS_PENDING_BG,
  UI_COLOR_SECONDARY,
  UI_COLOR_TRANSPARENT,
  UI_COLOR_WARNING_ACCENT
} from '../../../constants/uiColors'

export const RBAC_USER_DETAIL_TAB_VALUE = 'detail'
export const RBAC_USER_ASSIGNED_DATA_TAB_VALUE = 'assigned-data'
export const RBAC_USER_HISTORY_TAB_VALUE = 'history'
export const RESEND_COOLDOWN_TICK_MS = 30000

export const rbacUserDetailTitleSx = {
  fontSize: 16,
  m: 0,
  lineHeight: 1.3
}

export const RBAC_USER_DETAIL_TABS = [
  {
    value: RBAC_USER_DETAIL_TAB_VALUE,
    label: 'Detalle',
    icon: Info,
    iconSize: 18,
    iconWeight: 'regular'
  },
  {
    value: RBAC_USER_ASSIGNED_DATA_TAB_VALUE,
    label: 'Datos asignados',
    icon: Funnel,
    iconSize: 18,
    iconWeight: 'regular'
  },
  {
    value: RBAC_USER_HISTORY_TAB_VALUE,
    label: 'Historial',
    icon: Clock,
    iconSize: 18,
    iconWeight: 'regular'
  }
]

export const RBAC_USER_DETAIL_TEXTS = {
  loading: 'Cargando...',
  notFound: 'Usuario no encontrado.',
  backToUsersLabel: 'Volver a usuarios torre',
  detailTitle: 'Detalles del usuario',
  historyTitle: 'Historial del usuario',
  historySubtitle: 'Historial del usuario',
  appUserRelationCreated: 'Relación usuarios App creada',
  appUserRelationUpdated: 'Relación usuarios App editada',
  appUsersAdded: 'Usuarios agregados',
  appUsersRemoved: 'Usuarios retirados',
  appUsersPreviousSelection: 'Selección anterior',
  appUsersCurrentSelection: 'Usuarios seleccionados',
  appUsersAll: 'Todos los usuarios de Ubiqua App',
  appUsersNone: 'Sin usuarios asignados',
  summaryTitle: 'INFORMACIÓN DEL USUARIO',
  pendingTitle: 'Cuenta pendiente de activación:',
  pendingMessage:
    'Le enviamos un correo al usuario para que active su cuenta y defina su contraseña.',
  resendEmail: 'Reenviar correo',
  resendingEmail: 'Reenviando...',
  resendCooldownTooltip: 'Ya reenviaste este correo. Podrás intentarlo de nuevo en {time}.',
  resendModalTitle: '¿Reenviar el correo de invitación?',
  resendModalNotice:
    'Este usuario está pendiente de activación. Aún no ha iniciado sesión en la plataforma.',
  resendModalBody:
    'Le enviaremos de nuevo el correo para que active su cuenta y defina su contraseña. El enlace anterior dejará de ser válido.',
  deactivateModalTitle: '¿Inactivar a este usuario?',
  deactivateModalBody:
    'Mientras esté inactivo, no podrá iniciar sesión en Torre de Control. Puedes volver a activarlo cuando lo necesites.',
  activateModalTitle: '¿Activar a este usuario?',
  activateModalBody:
    'Volverá a tener acceso a Torre de Control con el rol y los permisos que tenía asignados. Podrá iniciar sesión de inmediato.',
  cancel: 'Cancelar',
  editUser: 'Editar usuario',
  activateUser: 'Activar usuario',
  deactivateUser: 'Inactivar usuario'
}

export const rbacPendingNoteColors = {
  accentColor: UI_COLOR_WARNING_ACCENT,
  backgroundColor: UI_COLOR_RBAC_STATUS_PENDING_BG
}

export const rbacPendingNoteSx = {
  mb: 2,
  px: { xs: 1.75, md: 2.25 },
  py: 1,
  borderLeftWidth: '3px'
}

export const rbacPendingNoteIconSx = {
  color: UI_COLOR_WARNING_ACCENT
}

export const rbacPendingNoteTitleSx = {
  color: UI_COLOR_WARNING_ACCENT
}

export const rbacPendingNoteMessageSx = {
  fontSize: '13px',
  lineHeight: 1.35
}

export const rbacResendButtonSx = {
  color: UI_COLOR_SECONDARY,
  fontSize: 14,
  fontWeight: 700,
  minWidth: 'auto',
  p: 0,
  borderRadius: 0,
  backgroundColor: UI_COLOR_TRANSPARENT,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: UI_COLOR_TRANSPARENT,
    textDecoration: 'underline'
  },
  '&.Mui-focusVisible': {
    backgroundColor: UI_COLOR_TRANSPARENT
  }
}

export const rbacDetailsDividerSx = {
  flexBasis: '100%',
  width: '100%',
  borderTop: 'var(--app-card-border)'
}
